<template>
  <div class="submit-detail-btn">
    <div
      class="history-button"
      @click="openHistoryRecord"
    >历史提交记录</div>
    <van-popup 
      class="menu-popup"
      v-model:show="showPopup"
      :close-on-click-overlay="true"
      position="bottom"
      round
      @close="showPopup = false"
    >
      <div class="menu-popup-wrap">
        <div class="head">
          <p class="label">查看历史提交记录</p>
          <van-icon class="close-btn" name="cross" @click="showPopup = false" />
        </div>
        <div class="tips-text">
          查看历史提交记录将跳转到新页面
        </div>
        
        <div class="record-list-wrap">
          <div class="no-data" v-if="!submitList.length">
            暂无历史提交记录
          </div>
          <div
            v-for="(item, index) in submitList"
            :key="index" 
            class="record-item"
            @click="toViewSubmit(item)"
          >
            <div class="text">
              <template v-if="item.update_time && item.update_time !== item.create_time">
                修改于 {{ $filters.formatDate(item.update_time, 'yyyy/MM/dd HH:mm') }}
              </template>
              <template v-else>
                首次提交于 {{ $filters.formatDate(item.create_time, 'yyyy/MM/dd HH:mm') }}
              </template>
            </div>
            <van-icon class="arrow-icon" name="arrow" />
          </div>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import { api } from "@/utils/fetch.js";
import { Icon, Popup } from 'vant';

export default {
  props: {
  },
  data() {
    return {
      showPopup: false,
      submitList: []
    };
  },
  computed: {
    formConfig() {
      return this.$store.state.formConfig;
    },
  },
  components: {
    [Icon.name]: Icon,
    [Popup.name]: Popup
  },
  methods: {
    openHistoryRecord() {
      this.showPopup = true;
      api.GetSubmitList({ form_id: this.formConfig.id }, true).then((res) => {
        this.submitList = res?.list?.length ? res.list : [];
      })
      .catch((e) => {
      });
    },
    toViewSubmit(item) {
      const query = {
        ...this.$route.query,
        readonly: 1,
        view_submit: 1,
        _t: new Date().getTime()
      };
      if (item?.id) {
        query.submit_id = item.id;
      }
      this.$router.push({
        path: '/index',
        query: query
      });
      this.showPopup = false;
    }
  },
  created() {},
  async mounted() {
  },
};
</script>

<style lang="less" scoped>
@import (reference) '@/assets/less/common.less';

.submit-detail-btn {
  .view-button {
    .submit-button();
  }
  .history-button {
    width: 100%;
    font-weight: 700;
    font-size: @font-size-2;
    height: 40px;
    line-height: 40px;
    border: 1px solid #E9E9E9;
    border-radius: 4px;
    color: @desc-color-1;
    text-align: center;
    box-sizing: border-box;
    margin-top: 16px;
  }
}

.menu-popup-wrap {
  padding: 0;
  background-color: #fff;
  .head {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 20px 24px;
    border-bottom: solid 1px #ddd;
    .label {
      font-weight: 700;
      font-size: 18px;
      line-height: 22px;
      color: @title-color;
    }
    .close-btn {
      color: @desc-color-1;
      font-size: 18px;
    }
  }
  .tips-text {
    font-size: 14px;
    color: #FAAD14;
    text-align: center;
    line-height: 42px;
    background-color: #fff7e7;
  }
  .no-data {
    font-size: 14px;
    color: @desc-color-2;
    text-align: center;
    line-height: 100px;
  }
  .record-list-wrap {
    height: 250px;
    overflow: auto;
    padding-bottom: 24px;
    .record-item {
      display: flex;
      justify-content: space-between;
      align-items: center;
      height: 52px;
      margin-left: 24px;
      padding-right: 20px;
      border-bottom: 1px solid #E9E9E9;
      .text {
        font-size: 14px;
        line-height: 20px;
        color: @desc-color-1;
      }
      .arrow-icon {
        color: var(--theme-main-color);
        font-size: 18px;
      }
    }
  }
}
</style>
